import React from 'react';
import HeroBanner from '../components/HeroBanner';
import ServiceCards from '../components/ServiceCards';

function LandingPage() {
  return (
    <>
      <HeroBanner />
      <ServiceCards />
    </>
  );
}

export default LandingPage;
